<script>
import { cloneDeep } from 'lodash';

export default {
  components: {
    TableFilter: () => import('@c/components/InsightDataTable/components/TableFilter/index.vue'),
    IconFont: () => import('@c/components/IconFont'),
  },
  props: {
    col: {
      type: Object,
      required: true,
    },
    meta: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tableStore: {
      type: Object,
      required: true,
    },
    filterMeta: {
      type: [Object, undefined],
      default: undefined,
    },
  },
  computed: {
    sort() {
      const { tableStore, col } = this;
      const { sortList } = tableStore.state;
      return sortList.find((s) => s.key === col.value);
    },
    filter() {
      const { tableStore, col } = this;
      const { filterList } = tableStore.state;
      return filterList.find((f) => f.key === col.value);
    },
  },
  render() {
    let {
      tableStore, col, sort, filter, filterMeta, meta,
    } = this;
    const label = this.$slots?.default?.[0]?.text
    // https://rbnqidugqp.feishu.cn/wiki/P33twX7TciumHjkzysIc9daonlg
    //  1. 投资者名称、基金名称支持筛选、搜索
    // 2. 首次签约时间支持排序
    const isLegalTeam = this.$store.state.user.roleName == '运营法律支持组' && this.$route.params.moduleInfoId == 'Object_1c98__u'
    if (isLegalTeam && ['Field_t008__u', 'fund_name__u'].includes(meta.apiName)) {
      const filterMetaData = {
        "filterKey": meta.apiName,
        "type": "OBJECT_REFERENCE",
        "operate": [
          {
            "label": "等于",
            "value": "EQ"
          },
          {
            "label": "包含",
            "value": "LIKE"
          }
        ],
        "scene": {
          "related_data_remote": "/metadata/data/getRelatedLayoutAndDataList",
          "element_props": {
            "customIcon": null
          },
          "optionKey": {
            "label": "name",
            "value": "id"
          },
          "reference": {
            "isSingle": true,
            "title": "管理相关项",
            "table_data_remote": "/metadata/data/getRelatedLayoutAndDataList",
            "moduleInfoId": "fund",
            "targetRelatedListName": "8i6rpnhz2900000000"
          }
        }
      }
      // col.sort = true
      filterMeta = filterMetaData
    }

    if (isLegalTeam && ['first_sign_date__u'].includes(meta.apiName)) {
      col.sort = true
    }

    // 数字/百分比/货币类型列：表头标签靠右，跟值对齐方式一致。
    // krTableByGm 渲染 th 时会给 th 加 align="right"，
    // 但内部 .header-cell-inner 是 flex 容器（justify-content: space-between），
    // flex 布局不受父 text-align 影响，所以这里按 align 切换 justify-content。
    const isRightAligned = col.align === 'right'
    const innerStyle = isRightAligned ? 'justify-content: flex-end;' : ''

    return (
      <span class="header-cell-inner" style={innerStyle}>
        <span class="header-cell-label" title={label}>{this.$slots.default}</span>
        <span class="header-operation">
          {col.sort ? (
            <icon-font
              class={`sort-arrow ${sort && sort.dir}`}
              name={`v_sort-${(sort && sort.dir) === 'asc' ? 'up' : 'down'}`}
              onclick={() => {
                this.tableStore.clearSort();
                this.tableStore.toNextSort({
                  ...sort,
                  key: col.value,
                  type: col.type,
                });
                this.$emit('sort-change', {
                  sorts: cloneDeep(this.tableStore.state.sortList),
                });
              }}
            />
          ) : null}
          {(col.filter || filterMeta) ? (<table-filter
              tableStore={ tableStore }
              col={ col }
              key={ col.value }
              meta={ meta }
              sort={ sort }
              filter={ filter }
              filterMeta={ filterMeta }
            >
          </table-filter>) : null }
        </span>
      </span>
    );
  },
};
</script>

<style lang="scss" scoped>
  .header-cell-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    // overflow: hidden;

    & .header-cell-label {
      display: block;
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
    }

    &:hover {
      .header-operation {
        & .sort-arrow {
          visibility: visible;
        }
      }
    }

    & .header-operation {
      flex-shrink: 0;
      font-weight: 400;
      margin-top: 1px;
      flex-shrink: 0;

      & .sort-arrow {
        color: #bbc;
        cursor: pointer;
        text-align: center;
        line-height: 24px;
        margin-right: 2px;
        display: inline-block;
        visibility: hidden;
        width: 24px;
        height: 24px;
        border-radius: 4px;

        &:hover {
          background-color: rgba(0, 0, 0, 0.06);
          color: $theme-color;
        }

        &.asc {
          color: $theme-color;
          visibility: visible;
        }

        &.desc {
          color: $theme-color;
          visibility: visible;
        }
      }
    }
  }
</style>
